<template>
  <section
    v-if="
      popularLocations &&
      popularLocations.locations &&
      popularLocations.locations.length > 0
    "
    class="seo-links"
    :data-lang="lang"
  >
    <translate
      v-if="popularLocations.categoryName"
      tag="h2"
      :tt="{ category: popularLocations.categoryName }"
    >
      Popular {category} locations
    </translate>
    <translate v-else tag="h2"> Popular campsite locations </translate>
    <div>
      <pu-link
        v-for="location of popularLocations.locations || []"
        :key="location.url"
        :path="location.url"
      >
        {{ location.name }}
      </pu-link>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { Pinia } from 'pinia'
import { setupLocations } from './service'

const route = useRoute()
const lang = (route.params.lang as string) || 'en-gb'
const path = computed(() => route.path)
const categories = computed(() => route.query.type)
const searchStore = useSearchStoreSetup(usePinia() as Pinia)

const { data: popularLocations } = useAsyncData(
  `popularLocations-${JSON.stringify(searchStore.searchFilters)}`,
  () => setupLocations(lang, route),
  {
    watch: [path, categories],
  },
)
</script>

<style scoped>
@import url('~/assets/css/seo-links.css');
</style>
